import ReviewQualifiedRealplay from '../Components/RealPlayViewQualified/ReviewQualifiedRealplay';
import { Redirect } from 'react-router-dom';
import { useShouldShowRealPlaysPage } from '../RealPlaysHook';
const RealPlayQualified = () => {
  const { loading, enabled: isEnabled } = useShouldShowRealPlaysPage();

  if (loading) return null;

  return isEnabled ? <ReviewQualifiedRealplay /> : <Redirect to="/" />;
};

export default RealPlayQualified;
